import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import PublicTopBar from "../components/PublicTopBar";
import Footer from "../components/Footer";
import NavBarPublic from "../components/NavBarPublic";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "white",
  },
  main: {
    padding: 0,
    display: "flex",
    flexDirection: "row",
  },
  footer: {
    padding: 0,
    backgroundColor: "white",
    height: 196,
    width: "100%",
  },
  content: {
    marginTop: "auto",
    marginBottom: "auto",
    minHeight: "calc(100vh - 196px)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <PublicTopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <Container component="main" className={classes.main}>
        <NavBarPublic
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
        <div className={classes.content}>{children}</div>
      </Container>
      <footer className={classes.footer}>
        <Footer />
      </footer>
    </div>
  );
};

export default MainLayout;
